var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error--outline_svg__clip0_61530_7336)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.917 6.75L6.75 7.917l9.334 9.333 1.166-1.166L7.917 6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5A10.435 10.435 0 001.5 12 10.435 10.435 0 0012 22.5 10.434 10.434 0 0022.5 12 10.434 10.434 0 0012 1.5zM12 21a9 9 0 119-9 9.026 9.026 0 01-9 9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error--outline_svg__clip0_61530_7336"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgErrorOutline;